import React from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { useDispatch } from 'react-redux';
import { Row, Col, Button, Form as BSForm } from 'react-bootstrap';
import * as Yup from 'yup';
import { debounceIndexJobManagementsRequest } from '../../requests/jobManagements';
import categories from './FormOptions';
import {
  FormikSelect,
  FormikInput,
  UploadImage,
  InputSelect,
  FormikRangePicker,
  DocumentEditor,
  UploadFile
} from '../../components';
import '../../services/yupCustomMethods';

const BenefitForm = ({ benefit, errors, touched, values, setFieldValue, setFieldTouched, isSubmitting }) => {
  const dispatch = useDispatch();
  const { startDate, endDate } = values.benefit;

  const fetchJobManagments = (inputValue, callback) => {
    debounceIndexJobManagementsRequest({
      dispatch,
      params: {
        actives: true,
        name: inputValue,
        sort_column: 'name',
        paginate: false
      },
      successCallback: data => {
        const result = data.data.data.map(element => ({
          ...element,
          label: element.name,
          value: element.id
        }));
        callback(result);
      }
    });
  };

  const handleNewJobManagement = (data, field) => {
    const newData = data.map(element => element.value);
    if (!newData.length) newData.push('');
    setFieldValue(field, newData);
  };

  return (
    <>
      <h2 className="mt-5 mb-3">Beneficios</h2>
      <div className="yellow-wrapper">
        <Form id="benefit-form" className="form-benefit">
          <Row>
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <Field name="benefit[name]">
                    {({ field }) => (
                      <FormikInput
                        {...field}
                        abbr
                        label="Nombre del beneficio"
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
                <Col md={6}>
                  <Field name="benefit[category]">
                    {({ field }) => (
                      <FormikSelect
                        {...field}
                        abbr
                        label="Categoría"
                        placeholder="Seleccionar categoría"
                        options={categories}
                        defaultValue={benefit.category}
                        onChange={data => setFieldValue(field.name, data ? data.value : '')}
                        setFieldTouched={() => setFieldTouched(field.name)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mt-2">
                  <Field name="rangeDate">
                    {({ field }) => (
                      <FormikRangePicker
                        {...field}
                        abbr
                        startDateName="benefit[startDate]"
                        endDateName="benefit[endDate]"
                        startDate={startDate}
                        endDate={endDate}
                        minCurrentDate
                        showClearDates
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
                <Col md={12} className="mt-2">
                  <Field name="benefit[link]">
                    {({ field }) => (
                      <FormikInput
                        {...field}
                        label="Link"
                        placeholder="https://peoplework.cl"
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col className="mt-3">
                  <Field name="benefit[benefitsImage]">
                    {({ field }) => (
                      <UploadImage
                        {...field}
                        name="Agregar imagen"
                        imageUrl={getIn(benefit.benefitsImage, 'fileUrl')}
                        onChange={image => setFieldValue(field.name, image)}
                        helpText="Formatos compatibles: jpg, png, jpeg, gif. Tamaño máximo 3mb."
                        fileAccept=".png, .jpg, .gif, .jpeg"
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col className="mt-3">
                  <Field name="benefit[attachedFile]">
                    {({ field }) => (
                      <UploadFile
                        {...field}
                        name="Archivo"
                        label="Documento adjunto"
                        helpText="Formatos: jpg, png, jpeg, gif, doc, docx, pdf. Máx 3MB"
                        onChange={file => setFieldValue(field.name, file)}
                        fileAccept=".png, .jpg, .jpeg, .gif, .doc, .docx, .pdf"
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col className="mt-5">
                  <Field name="benefit[notifyByEmail]">
                    {({ field }) => (
                      <BSForm.Check
                        {...field}
                        type="checkbox"
                        label="Notificación por correo"
                        checked={field.value}
                        onChange={e => setFieldValue(field.name, e.target.checked)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={6}>
                  <Field name="benefit[jobManagementIds]">
                    {({ field }) => (
                      <InputSelect
                        {...field}
                        isMulti
                        label="Área del Beneficio"
                        placeholder="Todas"
                        values={values.benefit}
                        model={[benefit, 'jobManagement']}
                        request={fetchJobManagments}
                        onChange={data => handleNewJobManagement(data || [], field.name)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
                <Col md={6}>
                  <Field name="benefit[position]">
                    {({ field }) => (
                      <FormikInput
                        {...field}
                        abbr
                        label="Posición"
                        inputType="number"
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field name="benefit[description]">
                    {({ field }) => (
                      <DocumentEditor
                        abbr
                        label="Descripción"
                        data={values.benefit.description}
                        onEditorChange={content => setFieldValue(field.name, content)}
                        onBlur={() => setFieldTouched(field.name, true)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    )}
                  </Field>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
      <Row className="mt-4">
        <Col className="d-flex justify-content-end">
          <Button type="submit" form="benefit-form" disabled={isSubmitting} variant="primary">
            GUARDAR
          </Button>
        </Col>
      </Row>
    </>
  );
};

const setInitialValues = props => {
  const {
    category,
    benefitsImage,
    attachedFile,
    description,
    endDate,
    jobManagementIds,
    jobManagements,
    link,
    name,
    position,
    startDate,
    notifyByEmail
  } = props.benefit;

  return {
    benefit: {
      attachedFile,
      category,
      benefitsImage,
      description,
      endDate,
      jobManagementIds,
      jobManagements,
      link,
      name,
      position,
      startDate,
      notifyByEmail: notifyByEmail || false
    },
    rangeDate: [startDate, endDate]
  };
};

const validationSchema = Yup.object().shape({
  benefit: Yup.object().shape({
    category: Yup.string().required('Debes seleccionar una categoría'),
    description: Yup.string().required('Debes ingresar una descripción'),
    endDate: Yup.date().formatdate(),
    link: Yup.string().url('Debes ingresar una URL válida'),
    name: Yup.string().required('Debes ingresar un nombre'),
    position: Yup.number()
      .required('Debes ingresar una posición')
      .typeError('Debes ingresar un número')
      .positive('Debe ser mayor a 0'),
    startDate: Yup.date().formatdate(),
    benefitsImage: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        'FILE_SIZE',
        'La imagen cargada excede el tamaño máximo permitido (3mb).',
        value => !value?.size || value?.size <= 3145728
      )
      .test(
        'FILE_FORMAT',
        'El archivo cargado tiene un formato no compatible.',
        value => !value?.type || ['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].includes(value?.type)
      ),
    attachedFile: Yup.mixed()
      .nullable()
      .notRequired()
      .test(
        'FILE_SIZE',
        'El archivo cargado excede el tamaño máximo permitido (3mb).',
        value => !value?.size || value?.size <= 3145728
      )
      .test(
        'FILE_FORMAT',
        'El archivo cargado tiene un formato no compatible.',
        value =>
          !value?.type ||
          [
            'image/jpg',
            'image/png',
            'image/jpeg',
            'image/gif',
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          ].includes(value?.type)
      )
  }),
  rangeDate: Yup.array().rangedate(true)
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(BenefitForm);
